define('viewModels/widgets/SortablePanels',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel'
], function (ko, _, ViewModel) {
    'use strict';

    var findIndex = function (collection, item) {
        return _.findIndex(collection, function (currentItem) {
            return currentItem === item;
        });
    };

    var SortablePanels = ViewModel.extend(function () {
        var self = this;

        var setPanelPriority = function () {
            _.each(self.panels(), function (panel, index) {
                panel.priority = index;
            });
        };

        self.panels = ko.observableArray();

        self.placeholderText = ko.i18n.renderString('sortablePanels.noData');

        self.activePanel = ko.observable();

        self.hasPanels = ko.pureComputed(function () { return self.panels().length > 0; });

		// If true, will disable sorting arrows and panels will instead be sorted alphabetically
        self.autoSort = ko.observable(false);

        // Toggles visibility of sorting arrows
        self.orderable = ko.observable(true);

        self.disabled = ko.observable(false);

        self.activatePanel = function (panel) {
            if(self.disabled()) {
                return;
            }

            if (!panel) {
                if (self.panels().length > 0) {
                    panel = self.panels()[0];
                }
            }

            var index = findIndex(self.panels(), panel);
            if (index > -1) {
                _.each(self.panels(), function (currentPanel) {
                    currentPanel.isActive(false);
                });
                self.panels()[index].isActive(true);
                self.activePanel(self.panels()[index]);
            }
        };

        self.deactivatePanel = function (panel) {
            var index = findIndex(self.panels(), panel);
            if (index > -1) {
                self.panels()[index].isActive(false);
                self.activePanel(undefined);
            }
        };

        self.createPanel = function (heading, viewModel, template, startingPriority) {
            startingPriority = startingPriority ? startingPriority : 0;

            var panel = {
                heading: heading,
                viewModel: viewModel,
                template: template,
                isActive: ko.observable(false),
                deleted: ko.observable(false),
                priority: startingPriority
            };
            panel.isFirst = ko.pureComputed(function () {
                return findIndex(self.panels(), panel) === 0;
            });
            panel.isLast = ko.pureComputed(function () {
                return findIndex(self.panels(), panel) === (self.panels().length - 1);
            });

            self.panels.push(panel);
			if(self.autoSort()) {
                // sorts the panels alphabetically based on their "heading" attribute
				self.panels.sort(function (a, b) {
                    // If the headings are the same, pass a 0 to the sort() function
                    if(ko.unwrap(a.heading) == ko.unwrap(b.heading)) {
                        return 0;
                    }
                    // else if the first heading is < the second one, pass a -1
                    else if(ko.unwrap(a.heading) < ko.unwrap(b.heading)) {
                        return -1;
                    }
                    // else the first one is > the second one, so pass a 1 to sort()
                    else {
                        return 1;
                    }
				});
			} else {
				self.panels.sort(function (a, b) {
					return ko.unwrap(a.priority) - ko.unwrap(b.priority);
				});
			}

            return panel;
        };

        self.removePanel = function (panel) {
            if(self.disabled()) {
                return;
            }

            if(self.activePanel() === panel) {
                self.activePanel(undefined);
            }

            self.panels.remove(panel);
            setPanelPriority();
        };

        self.undoRemovePanel = function(panel) {
            panel.deleted(false);
        };

        self.promotePanel = function (panel) {
            if(self.disabled()) {
                return;
            }
            var index = findIndex(self.panels(), panel);
            if (index > 0) {
                self.panels.splice(index - 1, 0, self.panels.splice(index, 1)[0]);
            }
            setPanelPriority();
        };

        self.demotePanel = function (panel) {
            if(self.disabled()) {
                return;
            }
            var index = findIndex(self.panels(), panel);
            if (index < self.panels().length - 1) {
                self.panels.splice(index + 1, 0, self.panels.splice(index, 1)[0]);
            }
            setPanelPriority();
        };

        self.previousPanel = function () {
            if(self.disabled()) {
                return;
            }
            var panel = self.activePanel();
            var index = findIndex(self.panels(), panel);
            if (index > -1 && self.panels()[index - 1]) {
                self.activatePanel(self.panels()[index - 1]);
            }
        };

        self.nextPanel = function () {
            if(self.disabled()) {
                return;
            }
            var panel = self.activePanel();
            var index = findIndex(self.panels(), panel);
            if (index > -1 && self.panels()[index + 1]) {
                self.activatePanel(self.panels()[index + 1]);
            }
        };

    });

    return SortablePanels;
});

